import React, { useEffect, useState } from 'react'
import FoodDetails from '../../components/food/details-modal'
import HOCFoodDetails from './HOCFoodDetails'

import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { getTmpFood, getViewFoodDetails } from '../../selectors'
import { setTmpFoods, setViewFoodDetails } from '../../actions/orderActions'
import { isNotEmpty } from '../../utils/helper'

const FoodDetailsModal = () => {
    const [foodShowIndex, setFoodShowIndex] = useState(0)
    const foodDetails = useSelector(getViewFoodDetails)
    const { tmpFood, lastItem } = useSelector(getTmpFood)
    const dispatch = useDispatch()
    const location = useLocation()

    const closeView = () => {
        setFoodShowIndex(0)
        dispatch(setViewFoodDetails(null))
    }

    const handleClose = () => {
        closeView()
        dispatch(setTmpFoods([]))
    }

    const handleSubmitSuccess = () => {
        lastItem && closeView()
    }

    const handleChangeFoodShow = index => setFoodShowIndex(index)

    const getFoodShow = f => {
        if (!f?.subs) {
            return f
        }

        return f.subs[foodShowIndex]
    }

    useEffect(() => {
        if (foodDetails) {
            dispatch(setTmpFoods([]))
            closeView()
        }
    }, [location.pathname])

    useEffect(() => {
        if (foodDetails && tmpFood) {
            const el = document.querySelector('.food-details-modal')
            el && (el.scrollTop = 0)
        }
    }, [tmpFood, foodDetails])

    useEffect(() => {
        foodDetails?.foodIndexSelected &&
            setFoodShowIndex(foodDetails.foodIndexSelected)
    }, [foodDetails])

    const { foodDetails: food, ...form } = tmpFood || {}

    return (
        <HOCFoodDetails
            FoodComponent={FoodDetails}
            goBack={handleSubmitSuccess}
            onClose={handleClose}
            foodDetails={
                tmpFood && foodDetails ? food : getFoodShow(foodDetails)
            }
            formGroupFood={isNotEmpty(form) ? form : undefined}
            isModal
            foodParent={foodDetails}
            foodSubs={foodDetails?.subs || []}
            handleChangeFoodShow={handleChangeFoodShow}
            foodShowIndex={foodShowIndex}
        />
    )
}

export default FoodDetailsModal
